<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="申请单号" class="EL-Form-Item">
                        <el-input v-model="pagination.samCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="pagination.matCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="pagination.matName" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="申请状态" class="EL-Form-Item">
                        <el-select v-model="pagination.status">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待审批" value="10"></el-option>
                            <el-option label="审批完成" value="20"></el-option>
                            <!-- <el-option label="待拣配" value="30"></el-option> -->
                            <el-option label="拣配中" value="40"></el-option>
                            <el-option label="拣配完成" value="50"></el-option>
                            <el-option label="出库完成" value="60"></el-option>
                            <el-option label="关闭" value="70"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="申请部门" class="EL-Form-Item">
                        <el-select v-model="pagination.section" placeholder="请选择" filterable clearable="clearable">
                            <el-option v-for="(item, index) in dictDataList" :key="index" :label="item.deptCode+' - '+item.deptName" :value="item.deptCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="拣配人员" class="EL-Form-Item">
                        <el-input v-model="pagination.operator" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.requireDate[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.requireDate[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>

            </el-form>
            <el-divider></el-divider>
            <plabel text="领用出库">
                <el-button class="btn-t-edit" v-authority="'BACK_MENU4_M12_B1'" v-if="quanbu == 0" @click="returnDelivery('TW')">TW领用出库</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU4_M12_B2'" v-if="quanbu == 0" @click="returnDelivery('IS')">IS领用出库</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU4_M12_B3'" v-if="quanbu == 0" @click="returnInventory()">退库</el-button>
                <el-button class="btn-t-delete" v-authority="'BACK_MENU4_M12_B4'" v-if="quanbu == 0" @click="closeGetDistribute()">关闭</el-button>
                <el-button v-authority="'BACK_MENU4_M12_B5'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="tableData" pagination :nowPage.sync="pageMap.pageNum" :pageSize.sync="pageMap.pageSize" :total.sync="pageMap.total" @selectionChange="selectAll">
                <el-table-column type="selection" align="center" :selectable="checkboxSelect"> </el-table-column>
                <el-table-column label="申请单号" prop="samCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="物料类型" prop="prodDesc" align="center">
                </el-table-column>
                <el-table-column label="需求数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="申请人员" prop="person" align="center">
                </el-table-column>
                <el-table-column label="申请部门" prop="section" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.section}} - {{scope.row.deptName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == '10'">待审批</div>
                        <div v-if="scope.row.status == '20'">审批完成</div>
                        <div v-if="scope.row.status == '30'">待拣配</div>
                        <div v-if="scope.row.status == '40'">拣配中</div>
                        <div v-if="scope.row.status == '50'">拣配完成</div>
                        <div v-if="scope.row.status == '60'">出库完成</div>
                        <div v-if="scope.row.status == '70'">关闭</div>
                    </template>
                </el-table-column>
                <el-table-column label="申请时间" prop="createTime" palign="center">
                </el-table-column>
                <el-table-column label="需求时间" prop="requireDate" align="center">
                </el-table-column>
                <el-table-column label="审批状态" prop="checkFlag" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkFlag == '10'">通过</div>
                        <div v-if="scope.row.checkFlag == '20'">不通过</div>
                    </template>
                </el-table-column>
                <el-table-column label="审批部门" prop="examineType" align="center">
                </el-table-column>
                <el-table-column label="退库位置" prop="returnLocation" palign="center">
                </el-table-column>
                <el-table-column label="退库数量" prop="returnQuan" align="center">
                </el-table-column>
                <el-table-column label="审批人员编号" prop="examineEmp" align="center">
                </el-table-column>
                <el-table-column label="拣配人员" prop="operator" align="center">
                </el-table-column>
                <el-table-column label="拣货数量" prop="pickQuan" align="center">
                </el-table-column>
                <el-table-column label="拣货备注" prop="pickRemark" align="center">
                </el-table-column>
                <el-table-column label="备注" prop="remark" align="center">
                </el-table-column>
                <el-table-column label="产品型号" prop="productModel" align="center">
                </el-table-column>
                <el-table-column label="工单数量" prop="orderQuantity" align="center">
                </el-table-column>
                <el-table-column label="寿命" prop="life" align="center">
                </el-table-column>
               <el-table-column label="工序" prop="ddName" align="center">
                </el-table-column>
            </h-table>
        </box>

        <!-- 领用出库 -->
        <el-dialog title="申请详情" :visible.sync="returnDialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)">
            <h-table :headerCellStyle="headerCellStyle" :style="$popups.harvestRecordStyle(0.70)" :data="returnData">
                <el-table-column label="申请单号" prop="samCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="需求数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="拣货数量" prop="pickQuan" align="center">
                </el-table-column>
                <el-table-column label="申请人员" prop="person" align="center">
                </el-table-column>
                <el-table-column label="部门" prop="section" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.section}} - {{scope.row.deptName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == '10'">待审批</div>
                        <div v-if="scope.row.status == '20'">审批完成</div>
                        <div v-if="scope.row.status == '30'">待拣配</div>
                        <div v-if="scope.row.status == '40'">拣配中</div>
                        <div v-if="scope.row.status == '50'">拣配完成</div>
                        <div v-if="scope.row.status == '60'">领用出库</div>
                        <div v-if="scope.row.status == '70'">关闭</div>
                    </template>
                </el-table-column>
                <el-table-column label="申请时间" prop="createTime" palign="center">
                </el-table-column>
                <el-table-column label="需求时间" prop="requireDate" align="center">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="returnClose" type="info" class="btn-t-info">取 消</el-button>
                <el-button @click="updateAuxiMaterialStatus()" type="danger" class="btn-t-edit">确认领用</el-button>
            </div>
        </el-dialog>

        <!-- 退库 -->
        <el-dialog title="退库" :visible.sync="returnExamineShow" class="fromDialog" :style="$popups.popups(0.8,0.9)">
            <h-table :headerCellStyle="headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" :data="examineData">
                <el-table-column label="申请单号" prop="samCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="需求数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="拣货数量" prop="pickQuan" align="center">
                </el-table-column>
                <el-table-column label="申请人员" prop="person" align="center">
                </el-table-column>
                <el-table-column label="部门" prop="section" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.section}} - {{scope.row.deptName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == '10'">待审批</div>
                        <div v-if="scope.row.status == '20'">审批完成</div>
                        <div v-if="scope.row.status == '30'">待拣配</div>
                        <div v-if="scope.row.status == '40'">拣配中</div>
                        <div v-if="scope.row.status == '50'">拣配完成</div>
                        <div v-if="scope.row.status == '60'">领用出库</div>
                        <div v-if="scope.row.status == '70'">关闭</div>
                    </template>
                </el-table-column>
                <el-table-column label="申请时间" prop="createTime" palign="center">
                </el-table-column>
                <el-table-column label="需求时间" prop="requireDate" align="center">
                </el-table-column>
                <el-table-column label="退库位置" prop="returnLocation" align="center" v-if="quanbu == 0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clicktext">
                            <el-select v-model="scope.row.returnLocation" placeholder="请选择" filterable remote :remote-method="remoteMethodLcCode">
                                <el-option v-for="item in lcCodeList" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">{{item.lcCode}}</el-option>
                            </el-select>
                        </span>
                        <span v-else>
                            {{ scope.row.returnLocation }}
                            <span @click="tabClick(scope.row)"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="退库数量" prop="returnQuan" align="center" v-if="quanbu == 0" width="150px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.returnQuan" style="width: 100%;line-height: 26px !important" size="mini" :min="0"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="已退库数量" prop="returnQuanOld" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="dataListDel(scope.row.samId)" class="btn-t-delete">删除</el-button>
                    </template>
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="returnConfirmClose" type="info" class="btn-t-info">取 消</el-button>
                <el-button @click="returnConfirm" :loading="examineQuerens" type="danger" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: "GetDistribute",
        data() {
            return {
                taskTab: "first",
                tableData: [],
                pageMap: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                },
                pagination: {
                    samCode: "",
                    matCode: "",
                    matName: "",
                    section: "",
                    person: localStorage.getItem("user"),
                    orderCode: "",
                    status: "50",
                    requireDate: [],
                    fcCode: localStorage.getItem("fcCode") || "",
                    checkFlag: '10',
                    person: '',
                    operator: ''
                },
                tableTotal: 0,
                quanbu: "0",
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },

                dictDataList: [],
                //全选
                checkList: [],

                examineData: [],
                //拣货
                returnDialogShow: false,
                returnData: [],
								returnType: '',

                //退库
                returnExamineShow: false,
                matQuan: "",
                laCode: "",
                //文本框
                clicktext: false,
                lcCodeList: [],

                downloadLoading: false, //下载中
                examineQuerens: false,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                //库位号查询动态加载
                lcCodeLoading: false,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
						this.pageMap.pageNum=1;
                        this.getAuxiMaterialData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[0]) {
                            return time.getTime() < new Date(_this.pagination.requireDate[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[1]) {
                            return time.getTime() > new Date(_this.pagination.requireDate[1]);
                        }
                    }
                }
            },
        },
        methods: {
            tabClick(row) {
                this.$set(row, "clicktext", true);
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            /* 远程搜索库位号 */
            remoteMethodLcCode(query) {
                if (query || query == 0) {
                    this.lcCodeLoading = true;
                    this.getSysLocationAll(query);
                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.lcCodeList != undefined) {
                            this.lcCodeList = this.lcCodeList.filter((item) => {
                                return (item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeList = [];
                }
            },
            /* 获取所有的库位 */
            getSysLocationAll(lcCode) {
                this.$http
                    .request({
                    url: "/api/location/getLaCodeAllByType",
                    method: "GET",
                    params: {
                        //lcType: "AD",
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: lcCode || "",
                    },
                    })
                    .then((resp) => {
                    if (resp.status == 100) {
                        if (resp.data && resp.data.list) {
                            this.lcCodeList = resp.data.list;
                        }else{
                            this.lcCodeList = [];
                        }
                    }
                    })
                    .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
            },
            //获取数据
            getAuxiMaterialData() {
                this.tableData = [];
                this.$http
                    .request({
                        url: "/api/auxiMaterial/getAuxiMaterialData",
                        method: "GET",
                        params: {
                            pageNum: this.pageMap.pageNum,
                            pageSize: this.pageMap.pageSize,
                            samCode: this.pagination.samCode || null,
                            matCode: this.pagination.matCode || null,
                            matName: this.pagination.matName || null,
                            section: this.pagination.section || null,
                            person: this.pagination.person || null,
                            orderCode: this.pagination.orderCode || null,
                            status: this.pagination.status || null,
                            //requireDate: this.pagination.requireDate,
                            beginTime: this.pagination.requireDate[0] || null,
                            endTime: this.pagination.requireDate[1] || null,
                            fcCode: this.pagination.fcCode || null,
                            checkFlag: this.pagination.checkFlag || null,
                            operator: this.pagination.operator || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.tableData = resp.data.list || [];
                            this.pageMap.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            closeGetDistribute(){
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "",
                        type: "warning",
                    });
                    return;
                }else{
                    this.$confirm("是否确认关闭该领用申请单? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/auxiMaterial/closeGetDistribute",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                },
                                data: this.checkList,
                            }).then((resp) => {
                                if (resp.status == 100) {
                                    this.getAuxiMaterialData();
                                    this.$message({
                                        message: "关闭成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "auxiMaterial：操作成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "warning",
                                    });
                                    this.logRemarks = "auxiMaterial：操作失败";
                                }
                            }).catch((error) => {});
                        })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
                } 
            },
            //退库
            returnInventory() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选申请出库单！",
                        type: "warning",
                    });
                    return;
                }
				for (var index in this.checkList) {
                    if (this.checkList[index].status != '60') {
                        this.$message({
                            message: "出库完成后可以退库！",
                            type: "warning",
                        });
                        return;
                    }
                    if(this.checkList[index].pickQuan == this.checkList[index].returnQuan){
                        this.$message({
                            message: "退库数量已达到需求数量！",
                            type: "warning",
                        });
                        return;    
                    }
                    this.checkList[index]['returnQuanOld'] = this.checkList[index].returnQuan;
                    //this.checkList[index].returnQuan= this.checkList[index].pickQuan-this.checkList[index].returnQuan;
                    this.checkList[index].returnQuan = this.checkList[index].pickQuan;
                };

                this.examineData = this.deepCopy(this.checkList);
                this.returnExamineShow = true
            },
            dataListDel(samId) {
                var index = this.examineData.findIndex(item => {
                    if (item.samId == samId) {
                        return true;
                    }
                })
                this.examineData.splice(index, 1)
            },

            /**
             * 退库
             */
            returnConfirmClose(){
                this.examineData = [];
                this.returnExamineShow = false
                this.getAuxiMaterialData();
            },
            returnConfirm() {
                let Quan = 0;
                let Location = 0;
                let mQuan = 0;
                let pickQuan = 0;
                this.examineData.forEach(function(item) {
                    if (item.returnLocation == undefined) {
                        Location += 1;
                        return;
                    }
                    if (item.returnQuan == undefined || item.returnQuan == 0) {
                        Quan += 1;
                        return;
                    }
                    if (item.returnQuan > (item.pickQuan-item.returnQuanOld) && item.directInventory == false) {
                        pickQuan += 1;
                        return;
                    }
                    if (item.returnQuan > (item.matQuan-item.returnQuanOld) && item.directInventory == true) {
                        mQuan += 1;
                        return;
                    }
                })
                if (Location != 0) {
                    this.$message({
                        message: "退回位置不能为空",
                        type: "warning",
                    });
                    return;
                }
                if (Quan != 0) {
                    this.$message({
                        message: "退回数量不能为空不能为0！",
                        type: "warning",
                    });
                    return;
                }
                if (pickQuan != 0) {
                    this.$message({
                        message: "退回数量不能超过实际拣货数量！",
                        type: "warning",
                    });
                    return;
                }
                if (mQuan != 0) {
                    this.$message({
                        message: "退回数量不能超过需求数量！",
                        type: "warning",
                    });
                    return;
                }

                if (this.examineData.length == 0) {
                    this.$message({
                        message: "没有退货单！",
                        type: "warning",
                    });
                    return;
                }
                this.$http.request({
                    url: "/api/auxiMaterial/returnConfirm",
                    method: "POST",
                    showLoading: true,
                    data: this.examineData,
                    params: {
                        person: localStorage.getItem("user"),
                        personNumber: localStorage.getItem("empNumber")
                    }
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.logRemarks = "auxiMaterial：操作成功";
                    } else {
                        this.$message({
                            message: resp.message,
                            type: "warning",
                        });
                        this.logRemarks = "auxiMaterial：操作失败";
                    }
                    this.systemLog();
                    this.examineData = [];
                    this.returnExamineShow = false;
                    this.getAuxiMaterialData();
                }).catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
            },

            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.status != "60" && row.status != "50") {
                    return false; // 不禁用
                } else {
                    return true; // 禁用
                }
            },

            /**
             * 获取库位
             */
            getLocationData() {
                this.$http.request({
                    url: "/api/location/getLaCodeAllByType",
                    method: "GET",
                    showLoading: true,
                    params: {
                        fcCode: localStorage.getItem("fcCode") || "",
                        whCode: "",
                        lcType: "AD",
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.lcCodeList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },
            //确认出库
            returnDelivery(outType) {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选申请单！",
                        type: "warning",
                    });
                    return;
                }
				for (var index in this.checkList) {
                    if (this.checkList[index].status != '50') {
                        this.$message({
                            message: "只有拣配完成可以出库！",
                            type: "warning",
                        });
                        return;
                    }
                };

                // this.panduan = false;
                this.returnData = this.checkList;
                this.returnDialogShow = true;
				this.returnType = outType || 'IS';
            },
			
            //确认出库
            updateAuxiMaterialStatus() {
                this.$http
                    .request({
                        url: "/api/auxiMaterial/updateAuxiMaterialStatus",
                        method: "POST",
                        showLoading: true,
                        data: this.returnData,
                        params: {
                            returnType: this.returnType,
                            person: localStorage.getItem("user"),
                            personNumber: localStorage.getItem("empNumber")
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            this.returnClose();
                            this.getAuxiMaterialData();
                            this.logRemarks = "auxiMaterial：领用出库确认操作成功";
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "warning",
                            });
                            this.logRemarks = "auxiMaterial：领用出库确认操作失败";
                        }
                        this.logContent = '申请单号：' + listString;
                        // this.systemLog();
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //获取部门
            getDictData() {
                this.$http.request({
                    url: "/api/tepartment/getDepartmentData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        fcCode: localStorage.getItem("fcCode") || ""
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.dictDataList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },

            // 关闭弹出框
            returnClose() {
                this.returnDialogShow = false;
                // this.checkList = [];
                this.returnData = [];
            },
            //全选
            selectAll(val) {
                this.checkList = val;
            },
            //重置
            resetData() {
                this.pagination = {
                    samCode: "",
                    matCode: "",
                    matName: "",
                    section: "",
                    person: localStorage.getItem("user"),
                    orderCode: "",
                    status: "50",
                    requireDate: [],
                    fcCode: localStorage.getItem("fcCode") || "",
                    checkFlag: '10',
                    person: ''
                };
                // this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    samCode: this.pagination.samCode || null,
                    matCode: this.pagination.matCode || null,
                    matName: this.pagination.matName || null,
                    section: this.pagination.section || null,
                    person: this.pagination.person || null,
                    orderCode: this.pagination.orderCode || null,
                    status: this.pagination.status || null,
                    //requireDate: this.pagination.requireDate,
                    beginTime: this.pagination.requireDate[0] || null,
                    endTime: this.pagination.requireDate[1] || null,
                    fcCode: this.pagination.fcCode || null,
                    checkFlag: this.pagination.checkFlag || null,
                    operator: this.pagination.operator || null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/auxiMaterial/getAuxiMaterialData',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.status == '10') {
                            c['status'] = '待审批'
                        } else if (c.status == '20') {
                            c['status'] = '审批完成'
                        } else if (c.status == '30') {
                            c['status'] = '待拣配'
                        } else if (c.status == '40') {
                            c['status'] = '拣配中'
                        } else if (c.status == '50') {
                            c['status'] = '拣配完成'
                        } else if (c.status == '60') {
                            c['status'] = '出库完成'
                        } else if (c.status == '70') {
                            c['status'] = '关闭'
                        }

                        if (c.checkFlag == '10') {
                            c['checkFlag'] = '通过'
                        } else if (c.checkFlag == '20') {
                            c['checkFlag'] = '不通过'
                        }

                        // if (c.directInventory == true) {
                        //     c['directInventory'] = '是'
                        // } else if (c.directInventory == false) {
                        //     c['directInventory'] = '否'
                        // }


                        if (c.section != undefined && c.deptName != undefined) {
                            c['section'] = c.section + '-' + c.deptName
                        }
                    })
                    const tHeader = ['申请单号', '物料编号', '物料描述', '物料类型', '需求数量', '申请人员', '部门', '状态', '申请时间', '需求时间', '审批状态', 
                        '审批部门', '退库位置', '退库数量', '审批人员编号','拣配人员', '拣货数量', '拣货备注', '备注','产品型号','工单数量','寿命','工序'
                    ]
                    const filterVal = ['samCode', 'matCode', 'matName', 'prodDesc', 'matQuan', 'person', 'section', 'status', 'createTime', 'requireDate', 'checkFlag', 
                        'examineType', 'returnLocation', 'returnQuan', 'examineEmp','operator', 'pickQuan', 'pickRemark', 'remark','productModel','orderQuantity','life','ddName'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '领用出库单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_auxi_material：导出领用出库记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },



            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "领用出库",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated() {
            this.getLocationData();
            this.getDictData();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>